import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Check if environment variables are set
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables!');
  console.error('Please create a .env file with:');
  console.error('REACT_APP_SUPABASE_URL=your_supabase_project_url');
  console.error('REACT_APP_SUPABASE_ANON_KEY=your_supabase_anon_key');
  throw new Error('Supabase configuration is missing. Please check your environment variables.');
}

// Global fetch wrapper with timeout to prevent indefinite hangs
const fetchWithTimeout = (resource, options = {}) => {
  const { timeout = 30000 } = options;
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  return fetch(resource, { ...options, signal: controller.signal })
    .finally(() => clearTimeout(id));
};

// Create a single Supabase client instance to avoid multiple GoTrueClient warnings
// Since we're using custom auth, we don't need Supabase Auth, but the client still initializes it
// Using a single instance prevents conflicts
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  global: {
    fetch: (url, opts) => {
      return fetchWithTimeout(url, { ...opts, timeout: 60000 }).catch(err => {
        if (err.name === 'AbortError') {
          console.error(`Supabase request timed out after 60s: ${url}`);
        }
        throw err;
      });
    }
  },
  auth: {
    persistSession: false, // Don't persist Supabase Auth sessions
    autoRefreshToken: false, // Don't auto-refresh tokens
    detectSessionInUrl: false // Don't detect sessions in URL
  }
});

// Export the same instance with an alias for custom auth to maintain compatibility
// This avoids creating multiple GoTrueClient instances
export const supabaseForCustomAuth = supabase;

// Expose for debugging
if (typeof window !== 'undefined') {
  window.supabase = supabase;
  window.supabaseForCustomAuth = supabaseForCustomAuth;
}